"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusShipmentsToJSON = exports.CustomerStatusShipmentsFromJSONTyped = exports.CustomerStatusShipmentsFromJSON = void 0;
var runtime_1 = require("../runtime");
function CustomerStatusShipmentsFromJSON(json) {
    return CustomerStatusShipmentsFromJSONTyped(json, false);
}
exports.CustomerStatusShipmentsFromJSON = CustomerStatusShipmentsFromJSON;
function CustomerStatusShipmentsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'variation': json['variation'],
        'info': !(0, runtime_1.exists)(json, 'info') ? undefined : json['info'],
        'percentage': json['percentage'],
        'orderDate': json['orderDate'],
        'isPreparingForShipment': json['isPreparingForShipment'],
    };
}
exports.CustomerStatusShipmentsFromJSONTyped = CustomerStatusShipmentsFromJSONTyped;
function CustomerStatusShipmentsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'variation': value.variation,
        'info': value.info,
        'percentage': value.percentage,
        'orderDate': value.orderDate,
        'isPreparingForShipment': value.isPreparingForShipment,
    };
}
exports.CustomerStatusShipmentsToJSON = CustomerStatusShipmentsToJSON;
//# sourceMappingURL=CustomerStatusShipments.js.map